import { helpers } 		from './sites/helpers.js';
import { example } 		from './sites/components/exapmple.js';

window.sites = {
	globals: {},

	init: function () {
		var self = this;

		example.init();

		self.fixedHeader();

		self.countReferences();
	},

	fixedHeader() {
		var self = this;


		if( jQuery(window).scrollTop() > 30) {
			jQuery( ".navigation" ).addClass( "style-fixed" );
		}
		else {
			jQuery( ".navigation" ).removeClass( "style-fixed" );
		}
	},

	countReferences() {
		jQuery(".references.slideshow").each( function() {
			let count = jQuery(this).find( ".tns-item" ).length;

			let recenze_word = "recenzí";
			if( count == 1 ) { recenze_word = "recenzi"; }
			if( count >= 2 && count <= 4 ) { recenze_word = "recenze"; }
			

			jQuery(this).find( ".tns-nav" ).prepend( `<span>zobrazujeme celkem ${count} ${recenze_word}</span>` );
		});
	},



	onresize() {
		var self = this;
		self.fixedHeader();
	},

	onscroll(position, previusPosition) {
		var self = this;
		self.fixedHeader();
	},
};

jQuery(document).ready(function ($) {
	sites.init();
});

window.addEventListener('scroll', function (e) {
	sites.onscroll();
});

window.addEventListener('resize', function (e) {
	sites.onresize();
});